import {createSlice} from '@reduxjs/toolkit';
import {createSelector} from 'reselect';

export const searchResultsSlice = createSlice({
  name: 'searchResults',
  initialState: {
    resultData: {},
    resourcesData: {},
    isResultDataFetching: false,
    notFoundError: false,
    isSearchResultDataError: false
  },
  reducers: {
    setResultData: (state, action) => {
      state.resultData = action.payload;
    },
    setNextPageData: (state, action) => {
      state.resultData.resources = state.resultData.resources.concat(action.payload.resources);
      state.resultData.nextPageLink = action.payload.nextPageLink;
    },
    setResourcesData: (state, action) => {
      state.resourcesData = action.payload;
    },
    setIsResultDataFetching: (state, action) => {
      state.isResultDataFetching = action.payload;
    },
    setNotFoundError: (state, action) => {
      state.notFoundError = action.payload;
    },
    setIsSearchResultDataError: (state, action) => {
      state.isSearchResultDataError = action.payload;
    }
  }
});

export const {
  setResultData,
  setNextPageData,
  setResourcesData,
  setIsResultDataFetching,
  setNotFoundError,
  setIsSearchResultDataError
} = searchResultsSlice.actions;

const searchResultsSelector = (state) => state.searchResults;

export const resultDataSelector = createSelector(
  [searchResultsSelector],
  (searchResultsData) => searchResultsData.resultData
);
export const resourcesDataSelector = createSelector(
  [searchResultsSelector],
  (searchResultsData) => searchResultsData.resourcesData
);
export const isResultDataFetchingSelector = createSelector(
  [searchResultsSelector],
  (searchResultsData) => searchResultsData.isResultDataFetching
);
export const notFoundErrorSelector = createSelector(
  [searchResultsSelector],
  (searchResultsData) => searchResultsData.notFoundError
);
export const isSearchResultDataErrorSelector = createSelector(
  [searchResultsSelector],
  (searchResultsData) => searchResultsData.isSearchResultDataError
);

export default searchResultsSlice.reducer;
